// extracted by mini-css-extract-plugin
export default {"root":"HeaderV5_root-ner","wrapper":"HeaderV5_wrapper-Lap","finished":"HeaderV5_finished-f3w","logoText":"HeaderV5_logoText-dQ0","backButton":"HeaderV5_backButton-EYJ"};